import { useEffect, useRef } from "react";
import { useLocation } from "react-router-dom";

export default function GaRouteTracker() {
  const location = useLocation();
  const lastPathRef = useRef(null);

  useEffect(() => {
    const path = location.pathname + location.search + location.hash;

    // Prevent duplicate sends (e.g., StrictMode dev double-invocation or re-renders)
    if (lastPathRef.current === path) return;
    lastPathRef.current = path;

    // Only send if gtag is available
    if (typeof window.gtag !== "function") return;

    window.gtag("event", "page_view", {
      page_path: path,
      page_location: window.location.href,
      page_title: document.title,
    });
  }, [location]);

  return null;
}
